module.exports = __webpack_public_path__ + "static/Icons_Abilities3c-a97ecd4fbf943e0e2ee63c3a1f926e2c.png";